const DistrictServiceImpl = require('./DistrictServiceImpl');
const ResourceCatalogServiceImpl = require('./ResourceCatalogServiceImpl');
const ResourceQueryServiceImpl = require('./ResourceQueryServiceImpl');
const ResourceAnalysisServiceImpl = require('./ResourceAnalysisServiceImpl');
const ResourceDispatchServiceImpl = require('./ResourceDispatchServiceImpl');
/**
 * @namespace
 * @memberOf G
 * @description 应急一张图服务，兼容一张图2.0服务(mapeditor)的 SDK
 */
const servicev2 = {
    DistrictServiceImpl,
    ResourceCatalogServiceImpl,
    ResourceQueryServiceImpl,
    ResourceAnalysisServiceImpl,
    ResourceDispatchServiceImpl
};
module.exports = servicev2;